// @flow

import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../../services/apiService/apiService';

const apiToastrMessages = {
  GET_LANE_CONTENTS_FAILED: 'Failure in fetching lane contents: ',
  GET_LANE_CONTENTS_EXCEPTION: 'Exception in fetching lane contents: ',
  GET_CELL_PREFIXES_FAILED: 'Failure in fetching cell prefixes: ',
  GET_CELL_PREFIXES_EXCEPTION: 'Exception in fetching cell prefixes: ',
  GET_CELL_LIST_FAILED: 'Failure in fetching cells: ',
  GET_CELL_LIST_EXCEPTION: 'Exception in fetching cells: '
};

export const createLaneActions = {
  GET_LANE_CONTENTS: 'GET_LANE_CONTENTS',
  GET_CELL_PREFIXES: 'GET_CELL_PREFIXES',
  GET_CELLS: 'GET_CELLS'
};

export const getLaneContentsAction = (obj: Object) => ({
  type: createLaneActions.GET_LANE_CONTENTS,
  payload: obj
});

export const getCellPrefixesAction = (obj: Object) => ({
  type: createLaneActions.GET_CELL_PREFIXES,
  payload: obj
});

export const getCellsAction = (obj: Object) => ({
  type: createLaneActions.GET_CELLS,
  payload: obj
});

export const getLaneContents = (zoneTypeId, laneId, laneType) => (
  dispatch: Function
) => {
  dispatch(
    getLaneContentsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log('Getting lane contents');

  const requestObj = {
    baseUrl: 'zoomWmsBaseUrl',
    apiEndPoint: 'getLaneContents',
    method: 'GET',
    replaceParamsArr: [
      { key: 'zoneTypeId', val: zoneTypeId },
      { key: 'laneType', val: laneType },
      { key: 'laneId', val: laneId }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getLaneContentsAction({
            isLoading: false,
            isLoaded: true,
            data: res.payload
          })
        );
        //  eslint-disable-next-line
        console.log('Zone details api call successful', res.payload);
      } else if (res.status === 'FAILURE') {
        dispatch(
          getLaneContentsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(`${apiToastrMessages.GET_LANE_CONTENTS_FAILED}, res= `, res);
      dispatch(
        getLaneContentsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error('Failure', res.errorMessage, {
        timeout: 3000
      });
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(apiToastrMessages.GET_LANE_CONTENTS_EXCEPTION, res);
      dispatch(
        getLaneContentsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error(
        'Exception',
        apiToastrMessages.GET_LANE_CONTENTS_EXCEPTION,
        res.errorMessage,
        {
          timeOut: 3000
        }
      );
    }
  };
  makeApiCall(requestObj);
};

export const getCellPrefixes = laneId => (dispatch: Function) => {
  dispatch(
    getCellPrefixesAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log('Getting lane contents');

  const requestObj = {
    baseUrl: 'zoomWmsBaseUrl',
    apiEndPoint: 'getCellPrefixes',
    method: 'GET',
    replaceParamsArr: [{ key: 'laneId', val: laneId }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getCellPrefixesAction({
            isLoading: false,
            isLoaded: true,
            data: res.payload
          })
        );
        //  eslint-disable-next-line
        console.log('Zone details api call successful', res.payload);
      } else if (res.status === 'FAILURE') {
        dispatch(
          getCellPrefixesAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(`${apiToastrMessages.GET_CELL_PREFIXES_FAILED}, res= `, res);
      dispatch(
        getCellPrefixesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error('Failure', res.errorMessage, {
        timeout: 3000
      });
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(apiToastrMessages.GET_CELL_PREFIXES_EXCEPTION, res);
      dispatch(
        getCellPrefixesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error(
        'Exception',
        apiToastrMessages.GET_CELL_PREFIXES_EXCEPTION,
        res.errorMessage,
        {
          timeOut: 3000
        }
      );
    }
  };
  makeApiCall(requestObj);
};

export const getCells = (laneId, selectedPrefixes) => (dispatch: Function) => {
  dispatch(
    getCellsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log('Getting lane contents');

  const requestObj = {
    baseUrl: 'zoomWmsBaseUrl',
    apiEndPoint: 'getCellList',
    method: 'GET',
    replaceParamsArr: [
      { key: 'laneId', val: laneId },
      { key: 'prefixCSV', val: selectedPrefixes }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getCellsAction({
            isLoading: false,
            isLoaded: true,
            data: res.payload
          })
        );
        //  eslint-disable-next-line
        console.log('Zone details api call successful', res.payload);
      } else if (res.status === 'FAILURE') {
        dispatch(
          getCellsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(`${apiToastrMessages.GET_CELL_LIST_FAILED}, res= `, res);
      dispatch(
        getCellsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error('Failure', res.errorMessage, {
        timeout: 3000
      });
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(apiToastrMessages.GET_CELL_LIST_EXCEPTION, res);
      dispatch(
        getCellsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error(
        'Exception',
        apiToastrMessages.GET_CELL_LIST_EXCEPTION,
        res.errorMessage,
        {
          timeOut: 3000
        }
      );
    }
  };
  makeApiCall(requestObj);
};
